module.exports = __webpack_public_path__ + "static/0004-778422474f5e3c38377aeb5142ceb258.png";